export default {"src":"/_next/static/media/rejected-quotation.5e030633.svg","height":164,"width":230};